import React from 'react';
import { IContent } from '../../../types';
import { FranchiseItem } from '../../../types/content';
import { withContent } from '../../../hoc/withContext';
import './FranchiseElement.scss';
import { getShopURL, sendEvent } from '../../../utils';

import Image from "../../UI/Image/Image";

interface IFranchiseElementProps {
  context?: IContent;
  item: FranchiseItem;
}

const FranchiseElement = ({ item }: IFranchiseElementProps) => {
  const { image, link, title, tracking } = item;
  return (
    <div className="element-franchise">
      <a
        href={getShopURL() + link}
        onClick={() => sendEvent(tracking)}
      >
        <span className="game-logo">
          <Image
            className={["desktop"]}
            imageName={`franchise-${image}-desktop.png`}
            altText={title}
          />
          <Image
            className={["mobile"]}
            imageName={`franchise-${image}-mobile.png`}
            altText={title}
          />
        </span>
      </a>
    </div>
  );
};

export default withContent(FranchiseElement);
